import React, { useEffect, useState} from "react";
import Header from "../components/Header";
import { Link , useNavigate ,} from "react-router-dom";
import { BsPlus, BsPerson, BsGeoAlt, BsQuestionLg, BsMegaphone, BsCalendar4Event, BsBellFill, BsQuote, BsCardList, BsCodeSlash, BsArrowRepeat, BsDoorOpen } from "react-icons/bs";
import point from "../images/point.svg";
import mpIcon1 from "../images/mpIcon1.svg";
import mpIcon2 from "../images/mpIcon2.svg";
import mpIcon3 from "../images/mpIcon3.svg";
import mpIcon4 from "../images/mpIcon4.svg";
import Product1 from "../components/Product1";
import { useAxios } from "../services/useAxios";
import { useTranslation } from 'react-i18next';

import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';



export default function MyPage (){

    const { t } = useTranslation();
    const navigate = useNavigate();
    
    const userInfo = JSON.parse(localStorage.getItem("user")).data;

    const [request] = useAxios();
    const [myAccmlMlgAmount, setMyAccmlMlgAmount] = useState(0);
    const [myAccmlCouponCnt, setMyAccmlCouponCnt] = useState(0);
    const [myInqryCnt, setMyInqryCnt] = useState(0);

    const [recentGoods, setRecentGoods] = useState(localStorage.getItem("recentGoods")?JSON.parse(localStorage.getItem("recentGoods")):[]);
    

    
    useEffect(()  => {
        async  function getMyInfo(){
            const response = await request.post("/app/mypage/getMySaleeAPI", {});
            if(response.data.resultCode === 200){
                console.log(response.data.result)
                setMyAccmlMlgAmount(response.data.result.myAccmlMlgAmount);
                setMyAccmlCouponCnt(response.data.result.myAccmlCouponCnt);
                setMyInqryCnt(response.data.result.myInqryCnt);
            }
            
        }
        getMyInfo();

    }, []);

    const logout = (e) =>{
        e.preventDefault();    
        localStorage.removeItem("user");
        localStorage.removeItem("cartCookie");
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        navigate("/", { replace: true });                
    };
    
   
    

    return (
        <div>
            <div className="backGround bgBlue"></div>
            <Header type="search"  handleBack={(e) => navigate("/") } pageTitle="마이페이지"/>


            
            <div className="mypageArea">
                <h3 className="cFFF fs15 fw600">Hello, {userInfo.userNm} {t(`Message.my_salee_screen_user_sir`)}</h3>

                <div className="mpCont1">
                    <Link to="/MilegeHistory">
                        <ul className="myMilege dfsb">
                            <li>
                                <img src={point} alt="동전" />
                                <p className="fs13 cFFF">{t(`Message.my_salee_screen_user_mileage`)}</p>
                            </li>
                            <li>
                                <p className="fw600 fs14 cFFF">{!myAccmlMlgAmount?0:myAccmlMlgAmount.toLocaleString('ko-KR')}</p>
                            </li>
                        </ul>
                    </Link>
                    <div className="quickLink dfcs">
                        <Link to="/OrderHistory" className="mpql">
                            <img src={mpIcon1} alt={t(`Message.my_salee_screen_order_dtl`)} />
                            <p>{t(`Message.my_salee_screen_order_dtl`)}</p>
                        </Link>
                        <Link to="/Review" className="mpql">
                            <img src={mpIcon2} alt={t(`Message.my_salee_screen_goods_review`)} />
                            <p>{t(`Message.my_salee_screen_goods_review`)}</p>
                        </Link>
                        <Link to="/CouponAvail" className="mpql">
                            <img src={mpIcon3} alt={t(`Message.my_salee_screen_coupon`)} />
                            <p>{t(`Message.my_salee_screen_coupon`)} <span className="cOrg">{!myAccmlCouponCnt?0:myAccmlCouponCnt.toLocaleString('ko-KR')}</span></p>
                        </Link>
                        <Link to="/Inquiry" className="mpql">
                            <img src={mpIcon4} alt={t(`Message.my_salee_screen_inquiry`)} />
                            <p>{t(`Message.my_salee_screen_inquiry`)} <span className="cOrg">{!myInqryCnt?0:myInqryCnt.toLocaleString('ko-KR')}</span></p>
                        </Link>
                    </div>
                </div>


                <div className="mpc mpCont2">
                    <h3 className="tit">최근 본 상품</h3>
                    <div>
                        <Swiper className="recentlyViewedSlide" 
                            slidesPerView={1.15}
                            spaceBetween={12}
                        >
                            
                            {recentGoods && recentGoods.map((obj, index) => (  
                            <SwiperSlide key={index}>
                                <Product1 type="type1" 
                                prodName={obj.goodsNm}
                                disprice={"￦"+(!obj.sleAmount?0:obj.sleAmount).toLocaleString('ko-KR')}
                                obj = {obj}
                                setRecentGoods = {setRecentGoods}
                                img={"https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn="+obj.goodsImageSn}
                                />
                            </SwiperSlide>
                            ))}                            
                        </Swiper>
                    </div>
                </div>


                <div className="mpc mpCont3">
                    <h3 className="tit">{t(`Message.my_salee_screen_user_info_manage`)}</h3>
                    <div className="linkWr">
                        <Link to="/ChangeMemberInfo" className="mpLinkBtn rightArrow">
                            <div className="iconWr">
                                <BsPerson className="fs18"/>
                            </div>
                            <p className="tit">{t(`Message.my_salee_screen_user_info_chg`)}</p>
                        </Link>
                        <Link to="/DelivManagement" className="mpLinkBtn rightArrow">
                            <div className="iconWr">
                                <BsGeoAlt/>
                            </div>
                            <p className="tit">{t(`Message.my_salee_screen_dlvy_manage`)}</p>
                        </Link>                     
                    </div>
                </div>


                <div className="mpc mpCont4">
                    <h3 className="tit">{t(`Message.my_salee_screen_customer_support`)}</h3>
                    <div className="linkWr">
                        <Link to="/OftenQnA" className="mpLinkBtn rightArrow">
                            <div className="iconWr">
                                <BsQuestionLg />
                            </div>
                            <p className="tit">{t(`Message.my_salee_screen_favorite_quest`)}</p>
                        </Link>
                        <Link to="/Notice" className="mpLinkBtn rightArrow">
                            <div className="iconWr">
                                <BsMegaphone />
                            </div>
                            <p className="tit">{t(`Message.my_salee_screen_notice`)}</p>
                        </Link>
                        <Link to="/Event" className="mpLinkBtn rightArrow">
                            <div className="iconWr">
                                <BsCalendar4Event />
                            </div>
                            <p className="tit">{t(`Message.my_salee_screen_event`)}</p>
                        </Link>
                        {/* <Link to="/AlarmSet" className="mpLinkBtn rightArrow">
                            <div className="iconWr">
                                <BsBellFill />
                            </div>
                            <p className="tit">{t(`Message.my_salee_screen_noti_setting`)}</p>
                        </Link> */}
                    </div>
                </div>


                <div className="mpc mpCont5">
                    <h3 className="tit">{t(`Message.my_salee_screen_infomation`)}</h3>
                    <div className="linkWr">
                        <Link to="/TermsPrivat" className="mpLinkBtn rightArrow">
                            <div className="iconWr">
                                <BsQuote className="fs18"/>
                            </div>
                            <p className="tit">{t(`Message.my_salee_screen_privacy_policy`)}</p>
                        </Link>
                        <Link to="/TermsOfUse" className="mpLinkBtn rightArrow">
                            <div className="iconWr">
                                <BsCardList />
                            </div>
                            <p className="tit">{t(`Message.my_salee_screen_service_terms`)}</p>
                        </Link>
                        {/* <Link to="OpenSource" className="mpLinkBtn rightArrow">
                            <div className="iconWr">
                                <BsCodeSlash />
                            </div>
                            <p className="tit">{t(`Message.my_salee_screen_open_source_license`)}</p>
                        </Link>
                        <Link to="Version" className="mpLinkBtn rightArrow">
                            <div className="iconWr">
                                <BsArrowRepeat />
                            </div>
                            <p className="tit">{t(`Message.my_salee_screen_version_info`)} <span>v1.0</span></p>
                        </Link>                       */}
                    </div>
                </div>

                <button type="button" onClick={logout} className="mpLinkBtn">
                    <div className="iconWr">
                        <BsDoorOpen />
                    </div>
                    <p className="tit">{t(`Message.my_salee_screen_logout`)}</p>
                </button>
            </div>
        </div>
    );
};